<template>
  <div class="portal-page not-found">
    <div class="portal-page__inner not-found__inner portal-panel">
      <p class="not-found__code">404</p>
      <h1 class="not-found__title">페이지를 찾을 수 없습니다</h1>
      <p class="not-found__desc">주소가 변경되었거나 삭제된 페이지일 수 있습니다.</p>
      <div class="not-found__actions">
        <router-link to="/" class="portal-btn portal-btn--primary">홈으로</router-link>
        <router-link to="/search" class="portal-btn portal-btn--secondary">통합 검색</router-link>
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="./NotFoundPage.scss"></style>
